<template>
  <div>
    <img :src="src" :alt="alt" />
  </div>
</template>

<script>
export default {
  name: "app-logo",
  props: {
    src: {
      type: String,
      default: "/img/rapihogar.png",
    },
    alt: {
      type: String,
      default: "Rapihogar",
    },
  },
};
</script>

<style>
img {
    width: 100%;
}
</style>